export default __webpack_public_path__ + "3ddcc2c1cf94d8fd51a8ffb1630a0387.png";